import { useEffect, useState, useReducer } from 'react';

/**
 * Custom hook to handle hot module reloading
 * This forces immediate component updates without reloads
 */
export const useHotReload = () => {
  const [isReloading, setIsReloading] = useState(false);
  const [updateKey, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    // Listen for HMR events without forcing full reloads
    if (import.meta.hot) {
      import.meta.hot.accept(() => {
        console.log('🔄 HMR Update accepted');
        forceUpdate();
      });
    }
  }, []);

  return { isReloading, updateKey, forceUpdate };
};